// src/utils/error-reporting.ts
interface ErrorInfo {
    componentStack: string;
  }
  
  interface ErrorReport {
    error: Error;
    errorInfo: ErrorInfo;
    timestamp: number;
    userAgent: string;
    url: string;
  }
  
  /**
   * Report error to error tracking service
   */
  export const reportError = (error: Error, errorInfo: React.ErrorInfo) => {
    const errorReport: ErrorReport = {
      error,
      errorInfo: {
        componentStack: errorInfo.componentStack || 'No component stack available'
      },
      timestamp: Date.now(),
      userAgent: navigator.userAgent,
      url: window.location.href
    };
  
    // In development, log to console
    if (process.env.NODE_ENV === 'development') {
      console.error('Error Report:', errorReport);
      return;
    }
  
    // In production, send to error tracking service
    // Example: sendToErrorTrackingService(errorReport);
  };
  
  /**
   * Format error for display
   */
  export const formatError = (error: Error): string => {
    return process.env.NODE_ENV === 'development' 
      ? `${error.name}: ${error.message}\n${error.stack}`
      : error.message;
  };
  
  /**
   * Check if error should be reported
   */
  export const shouldReportError = (error: Error): boolean => {
    // Ignore certain errors
    const ignoredErrors = [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications'
    ];
  
    return !ignoredErrors.some(ignored => error.message.includes(ignored));
  };